import { render, staticRenderFns } from "./Especial.vue?vue&type=template&id=df88cf26&"
import script from "./Especial.vue?vue&type=script&lang=js&"
export * from "./Especial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports